import axios from "axios";
import _ from "lodash";
import Vue from 'vue'
import StudyEstEukTechMapAdditDataApiService from "../../../components/application/study/Services/Api/StudyEstEukTechMapAdditDataApi";
import store from "../index.js.erb";

const studyEstEukTechMapAdditDataApi = StudyEstEukTechMapAdditDataApiService

const StudyEstEukTechMapAdditDataStore = {
    namespaced: true,
    state: {
        list_curriculums: [],
        list_educational_programs: [],
        list_disciplines: [],
        list_chairs: [],
        list_curriculum_lines: [],
        list_semesters: [],
        list_study_years: [],
        count_all_tech_maps: ''
    },

    getters: {

    },

    mutations: {
        setListEducationalPrograms(state, response){
            state.list_educational_programs = response
        },
        setListDisciplines(state, response){
            state.list_disciplines = response
        },
        setListChairs(state, response){
            state.list_chairs = response
        },
        setListCurriculums(state, response){
            state.list_curriculums = response
        },
        setCurriculumLinesTechMap(state, response){
            state.list_curriculum_lines = response
        },
        setSemesters(state, response){
            state.list_semesters = response
        },
        setStudyYears(state, response){
            state.list_study_years = response
        },
        setFormatControl(state, data){
            state.list_curriculum_lines[data.index].format_controls = data.values
        },
        addNewFormatControl(state, data){
            state.list_curriculum_lines[data.index].format_controls.push(data.value)
        },
        deleteNewFormatControl(state, data){
            state.list_curriculum_lines[data.index].format_controls.splice(data.index_format_control, 1)
        },
        resetStudyEstEukTechMapAdditDataStore(state){
            state.list_curriculums = []
            state.list_educational_programs = []
            state.list_disciplines = []
            state.list_chairs = []
            state.list_curriculum_lines = []
            state.list_semesters = []
            state.list_study_years = []
        },
        setCountAllTechMaps(state, response){
            state.count_all_tech_maps = response
        }
    },

    actions: {
        async getListEducationalPrograms({commit}) {
            const response = await studyEstEukTechMapAdditDataApi.index();
            if (_.isNull(response)) return;

            if (!response?.data.hasOwnProperty("error")) {
                commit("setListEducationalPrograms", response.data.educational_programs);
                commit("setListChairs", response.data.list_chairs);
            } else {
                console.log('error')
            }
        },
        async getAdditData({commit}, params) {
            const response = await studyEstEukTechMapAdditDataApi.show(params);

            if (_.isNull(response)) return;

            if (!response?.data.hasOwnProperty("error")) {
                commit("setListCurriculums", response.data.curriculums);
            } else {
                console.log('error')
            }
        },
        async getHoursPlan({commit}, params) {
            const response = await studyEstEukTechMapAdditDataApi.get_hours_plan(params);
            if (_.isNull(response)) return;

            if (!response?.data.hasOwnProperty("error")) {
                commit("setCurriculumLinesTechMap", response.data.curriculum_lines)
            } else {
                console.log('error')
            }
        },
        async getDisciplines({commit}, params) {
            const response = await studyEstEukTechMapAdditDataApi.get_disciplines(params);
            if (_.isNull(response)) return;

            if (!response?.data.hasOwnProperty("error")) {
                commit("setListDisciplines", response.data.list_disciplines);
            } else {
                console.log('error')
            }
        },
        async getSemesters({commit}, params) {
            const response = await studyEstEukTechMapAdditDataApi.get_semesters(params);
            if (_.isNull(response)) return;

            if (!response?.data.hasOwnProperty("error")) {
                commit("setSemesters", response.data.periods)
            } else {
                console.log('error')
            }
        },
        async getStudyYears({commit}) {
            const response = await studyEstEukTechMapAdditDataApi.get_study_years();
            if (_.isNull(response)) return;

            if (!response?.data.hasOwnProperty("error")) {

                commit("setStudyYears",  response.data)
            } else {
                console.log('error')
            }
        },
        async getCountTechMaps({commit}) {
            const response = await studyEstEukTechMapAdditDataApi.get_count_tech_maps();
            if (_.isNull(response)) return;

            if (!response?.data.hasOwnProperty("error")) {

                commit("setCountAllTechMaps",  response.data)
            } else {
                console.log('error')
            }
        },
    },
}

export default StudyEstEukTechMapAdditDataStore